import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import Segment from '../../../../components/Segment';
import Logo from '../../components/Logo';
import Background from '../../components/Background';

import VccImage from './vcc.png';
import VccImage2x from './vcc@2x.png';
import CourseImage from './course.png';
import CourseImage2x from './course@2x.png';
import CommunityImage from './community.png';
import CommunityImage2x from './community@2x.png';

import './style.scss';

const segment = new Segment();

class Confirmation extends React.Component {
  state = {
    isBooked: false,
  };

  componentWillMount() {
    const { isAuthenticated } = this.props;
    if (!isAuthenticated) {
      this.props.router.push({
        pathname: '/assessment',
      });
      return;
    }

    const { location: { state } } = this.props;
    this.setState({
      ...state,
    });
  }

  componentDidMount() {
    segment.trackLink(this.slackLink, 'step9_clicked_slack');
    segment.trackLink(this.homepageLink, 'step9_clicked_homepage');
  }

  getContent() {
    return (
      <div className="confirmation__content">
        <img src={VccImage} srcSet={`${VccImage2x} 2x`} />
        <img src={CourseImage} srcSet={`${CourseImage2x} 2x`} />
        <img src={CommunityImage} srcSet={`${CommunityImage2x} 2x`} />
      </div>
    );
  }

  getBack() {
    return (
      <div className="confirmation__back">
        <div>
          <a
            ref={ref => {
              this.homepageLink = ref;
            }}
            href="https://www.paragonone.com"
          >
            Back to Homepage
          </a>
        </div>
      </div>
    );
  }

  getBooked() {
    return (
      <div>
        <div className="confirmation__heading">
          <div>Congratulations!</div>
          <div>Your booking is confirmed.</div>
        </div>
        <div className="confirmation__subheading">
          We’ll email you within 24 hours to schedule your first session. Any
          questions? Contact{' '}
          <a
            className="confirmation__link"
            href="mailto:advisor@paragonone.com"
          >
            advisor@paragonone.com
          </a>.
        </div>
        <div className="confirmation__subheading">
          In the meantime, join our community in Slack, the online messaging
          platform. It’s included with your purchase.{' '}
          <a
            className="confirmation__link"
            href="https://join.slack.com/t/paragonone-community/shared_invite/enQtMzIzODI4MjU0OTgyLWE3ZDM1NjE3Mzk1MTllNDViNGRlMDkxMzI5OTEyZmVhZjM3NzdmYjI1MzBhMzNkZWY5OTc1Y2UwZWFiNzVkNmM"
            target="_blank"
          >
            Click here to sign up now!
          </a>
        </div>
      </div>
    );
  }

  getSkipped() {
    return (
      <div>
        <div className="confirmation__heading">
          <div>Not ready to speak to an advisor?</div>
          <div>We’ve got you!</div>
        </div>
        <div className="confirmation__subheading">
          In the meantime, join our community in Slack, the online messaging
          platform.{' '}
          <a
            className="confirmation__link"
            href="https://www.google.com/url?q=https://join.slack.com/t/paragonone-community/shared_invite/enQtMzIzODI4MjU0OTgyLWE3ZDM1NjE3Mzk1MTllNDViNGRlMDkxMzI5OTEyZmVhZjM3NzdmYjI1MzBhMzNkZWY5OTc1Y2UwZWFiNzVkNmM&sa=D&ust=1521231645488000&usg=AFQjCNHXD8pqxJ5GuRrDd23vmHQ4nxFWPg"
            target="_blank"
          >
            Click here to sign up now!
          </a>
        </div>
      </div>
    );
  }

  getPhoneBooking() {
    return (
      <div>
        <div className="confirmation__heading">
          <div>Thanks for submitting your phone number</div>
          <div>
            We will call you within 24 business hours to see how we can help
            you.
          </div>
        </div>
        <div className="confirmation__subheading">
          In the meantime, join our community in Slack, the online messaging
          platform.{' '}
          <a
            ref={ref => {
              this.slackLink = ref;
            }}
            className="confirmation__link"
            href="https://www.google.com/url?q=https://join.slack.com/t/paragonone-community/shared_invite/enQtMzIzODI4MjU0OTgyLWE3ZDM1NjE3Mzk1MTllNDViNGRlMDkxMzI5OTEyZmVhZjM3NzdmYjI1MzBhMzNkZWY5OTc1Y2UwZWFiNzVkNmM&sa=D&ust=1521231645488000&usg=AFQjCNHXD8pqxJ5GuRrDd23vmHQ4nxFWPg"
            target="_blank"
          >
            Click here to sign up now!
          </a>
        </div>
      </div>
    );
  }

  render() {
    const { isBooked = null, phoneBooking = null } = this.state;

    // TODO: add personalized message + testimonials
    return (
      <div>
        <Background blue />
        <Logo white />
        <div className="assessment__wrapper--narrow">
          {!!isBooked && this.getBooked()}
          {!isBooked && this.getSkipped()}
          {!!phoneBooking && this.getPhoneBooking()}
          {/* {this.getContent()} */}
          {this.getBack()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authedUser: _.get(state, 'auth.User'),
  isAuthenticated: !!_.get(state, 'auth.sub'),
});

const mapDispatchToProps = {};

export default store => ({
  path: 'confirmation',
  component: connect(mapStateToProps, mapDispatchToProps)(Confirmation),
});



// WEBPACK FOOTER //
// ./src/routes/assessment/routes/Confirmation/index.js